import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getVoiceTranscriptionJobs = async (activityId) => {
    const { data } = await vlqrApi.get(`VoiceTranscriptionJobs/${activityId}/Jobs`)
        .catch((error) => {
            handleError(error);
        });
    return data;
};

const useVoiceTranscriptionJobsForActivity = (activityId) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['voiceTranscriptionJobs', activityId],
        queryFn: () => getVoiceTranscriptionJobs(activityId)
    });

    return { data, refetch, isLoading, isError };
};

export default useVoiceTranscriptionJobsForActivity;
